import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Routes from './Routes'
import { ThemeContextProvider } from 'Contexts/ThemeContext'
import AntdApp from 'antd/lib/app'
import { BrowserRouter } from 'react-router-dom'
import { MessageProvider } from 'shared/contexts/MessageContext'
import { MathJaxContext } from 'better-react-mathjax'
import { UserProfileProvider } from 'shared/auth/contexts/UserProfileContext'

const App: React.FC = () => {
    useEffect(() => {
        console.log('monorepo build')
    }, [])

    return (
        <AntdApp>
            <UserProfileProvider>
                <ThemeContextProvider>
                    <QueryClientProvider
                        client={
                            new QueryClient({
                                defaultOptions: {
                                    queries: {
                                        refetchOnWindowFocus: false,
                                        staleTime: 30_000,
                                        retry: false,
                                    },
                                },
                            })
                        }
                    >
                        <MessageProvider>
                            <BrowserRouter>
                                <MathJaxContext
                                    config={{
                                        tex: {
                                            inlineMath: [
                                                ['\\(', '\\)'],
                                                ['$', '$'],
                                            ],
                                        },
                                    }}
                                >
                                    <Routes />
                                </MathJaxContext>
                            </BrowserRouter>
                        </MessageProvider>
                    </QueryClientProvider>
                </ThemeContextProvider>
            </UserProfileProvider>
        </AntdApp>
    )
}

export default App
